// ControlFileAttachmentFactory.js
import $ from 'jquery';
import RestService from 'RestService.js';
import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService from 'FactoryService.js';
import constants from 'Constants.js';
import sequenceService from 'SequenceService.js';

import ControlModel from 'ControlModel.js';
import FileAttachmentControlView from 'advanced-inputs/FileAttachmentControlView.js';

//=============================================================================
//
// Creates a file attachment control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Maty Rocha, February 17, 2016
//
//=============================================================================
class ControlFileAttachmentFactory extends BaseVisualControlFactory {
    constructor() {
        super();
    }

    createView(factoryKey, pos) {

        const attributes = this.createChildAttributes(factoryKey, pos);

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.fileSize = RestService.getProfile().MaxAttachmentSize;
        attributes.maxSize = RestService.getProfile().MaxAttachmentSize;
        attributes.buttonLabelAttach = 'Attach';
        attributes.buttonLabelDetach = 'Detach';
        attributes.filetypes = '0';
        attributes.buttonLeft = 'checked';
        attributes.buttonPositionLeft = 'true';
        attributes.styleBGColorText = '#FFFFFF';
        attributes.styleBGColor2Text = '#FFFFFF';
        attributes.buttonBoldSelection = 'transparent';
        attributes.buttonItalicSelection = 'transparent';

        attributes.selectFields = [{ text: 'Attachment Id' }, { text: 'Attachment Name' }, { text: 'Attachment File' }];

        attributes.buttonTextColor = '~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle = '~inputFont';
        attributes.styleBGColorText = '~inputBgColor';

        attributes.styleColorText = '#333333';
        attributes.borderColor = '~buttonBorderColor';
        attributes.buttonBackgroundColor = '~buttonBgColor';
        attributes.buttonBackgroundGradientColor = '~buttonBgGradientColor';
        // Button Styles
        attributes.buttonTextColor = '~buttonTextColor';
        attributes.buttonFontFamily = '~buttonFont';
        attributes.buttonFontSize = '~buttonFont';
        attributes.buttonTextWeight = '~buttonFont';
        attributes.buttonTextStyle = '~buttonFont';
        attributes.resizePadding = 2;
        attributes.minWidth = 10;
        
        attributes.lowestHeight = 22;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
            {key:"buttonLabelAttach", label:"Attach Label"},
            {key:"buttonLabelDetach", label:"Detach Label"}
        ];
        
        if (pos && pos.id){ //PF-5410 - Behaviors - File attachment issues on saved/published forms
            attributes.id = pos.id;
        }

        return new FileAttachmentControlView({
            model: new ControlModel(attributes),
            el: $(constants.FORM_ID),
            pos: pos,
            factoryKey: factoryKey,
            id: attributes.id
        });
    }

}

const controlFileAttachmentFactory = new ControlFileAttachmentFactory();
export default controlFileAttachmentFactory;